import axios from 'axios';
import LoginService from '../acesso/login.service';

const API_URL = process.env.VUE_APP_BASE_URL + '/api/transferencias/';

class TransferenciasService{
  constructor(){
		LoginService.currentUser.subscribe(data => {
			this.headers = {
				'Content-Type':'application/json',
				'authorization':'Bearer ' + (data ? data.token:'')
			};
		});
	}

  findTransferenciasByFiltro(idContribuinte, filtro){
    return axios.get(API_URL+'allTransferencias?idContribuinte='+idContribuinte+'&filtro='+filtro, {headers: this.headers});
  }

  findObrasByFiltro(idContribuinte, filtro){
    return axios.get(API_URL+'allObras?idContribuinte='+idContribuinte+'&filtro='+filtro, {headers: this.headers}).then(response => (this.data = response.data));
  }

  findFornecedorByFiltro(idContribuinte, filtro){
    return axios.get(API_URL+'allContribFornecedor?idContribuinte='+idContribuinte+'&filtro='+filtro, {headers: this.headers}).then(response => (this.data = response.data));
  }

  getTransferencias(id){
    return axios.get(API_URL+id, {headers: this.headers});
  }

  saveTransferencias(transferencias){
    console.log(transferencias);
    return axios.post(API_URL, JSON.stringify(transferencias), {headers: this.headers});
  }

  upload(idCliente, idUsuario, idContribuinte, file) {
		const formData = new FormData()
		formData.append('file', file, file.name)
		return axios.post(API_URL+'upload?idCliente='+idCliente+'&idUsuario='+idUsuario+'&idContribuinte='+idContribuinte, formData, { headers: this.headers });
  }

  uploadNfeXml(idCliente, idUsuario, idContribuinte, numeroCei, file) {
		const formData = new FormData()
		formData.append('file', file, file.name)
		return axios.post(API_URL+'uploadNfeXml?idCliente='+idCliente+'&idUsuario='+idUsuario+'&idContribuinte='+idContribuinte+'&numeroCei='+numeroCei, formData, { headers: this.headers });
  }

  removeTransferencias(id){
    return axios.delete(API_URL+id, {headers: this.headers});
  }

  carregarAnexosTransferencia(idTransferencia){
    return axios.get(API_URL + 'allAnexosTransferencia?idTransferencia='+idTransferencia, {headers: this.headers});
  }

  downloadAnexo(id, type, nome) {
    return axios({
        url: API_URL + "exportTransferenciaAnexo?idAnexo=" + id,
        method: "POST",
        responseType: "blob",
        data: null,
        headers: this.headers
    }).then(response => {
      var fileURL = window.URL.createObjectURL(
        new Blob([response.data], { type: type })
      );
      var fileLink = document.createElement("a");
      fileLink.href = fileURL;
      console.log(response);
      fileLink.setAttribute("download", nome);
      document.body.appendChild(fileLink);
      fileLink.click();
    });
  }
}

export default new TransferenciasService();